import React from 'react';

/**
 * Подсказка по STYLESYSTEM (`tooltips.css`): hover, без AntD.
 * placement: bottom — под элементом (шапка); right — справа (свёрнутый левый сайдбар);
 * left — слева (правая helper-панель); top — над элементом.
 */
export default function MbTooltip({
  title,
  children,
  placement = 'bottom',
  className = '',
}) {
  if (!title) return children;
  const pos =
    placement === 'top' ? 'mb-tooltip--top' :
    placement === 'right' ? 'mb-tooltip--right' :
    placement === 'left' ? 'mb-tooltip--left' :
    'mb-tooltip--bottom';
  return (
    <span className={`mb-tooltip-wrap ${className}`.trim()}>
      {children}
      <span className={`mb-tooltip ${pos}`} role="tooltip">
        {title}
      </span>
    </span>
  );
}
